import Spinner from "~/atoms/icons/Spinner";

import type { ButtonProps } from "../Button";
import Button from "../Button";

/**
 * @param {string} label The label for the button
 * @param {bool} loading Whether or not the button is in a loading state
 * @returns A modified Button component that displays a spinning loader when the loading prop === true
 */

export interface ButtonLoadingProps extends ButtonProps {
  loading?: boolean;
}

const ButtonLoading: React.FC<ButtonLoadingProps> = ({
  children,
  customStyles = "",
  loading = false,
  color = "primary",
  ...rest
}) => (
  <Button
    endAdornment={
      loading && (
        <Spinner
          size="5"
          className="-m-0.5"
          color={color === "primary" ? "secondary" : "primary"}
        />
      )
    }
    customStyles={`${loading ? "pointer-events-none" : ""} ${customStyles}`}
    color={color}
    {...rest}
  >
    {children}
  </Button>
);

export default ButtonLoading;
